import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective'
import { useRef } from 'react';

export const InctvClaimLinePerspective = () => {

  const entityPerspectiveRef = useRef();

  const views = [
      {
        name: 'Combined',
        dims: ['RBT_PERIOD', 'PAYER_CUST','CUST', 'PROD', 'PROG'],
      kpis: ['INV_AMT', 'SALES_AMT','INV_QTY'],
      dimToPeriodicities: {
        RBT_PERIOD: ['YEAR', 'QTR', 'MON']
      }
      },

      {
        name: 'DSA',
        dims: ['RBT_PERIOD', 'PAYER_CUST','CUST', 'PROD', 'PROG'],
      kpis: ['INV_AMT', 'SALES_AMT','INV_QTY'],
      dimToPeriodicities: {
        RBT_PERIOD: ['YEAR', 'QTR', 'MON']
      }
      },
      {
        name: 'SD',
        dims: ['RBT_PERIOD', 'PAYER_CUST','CUST', 'PROD', 'PROG'],
      kpis: ['INV_AMT','SALES_AMT','INV_QTY'],
      dimToPeriodicities: {
        RBT_PERIOD: ['YEAR', 'QTR', 'MON']
      }
      }
    ]
  

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      
    />
  )
}